import { getFunctions, httpsCallable } from "firebase/functions";

export type CreateInvoiceReportResponse =
  | { ok: true; reportId: string; name: string; customer: string; count: number }
  | { ok: false; message?: string }
  | any;

export async function createInvoiceReportCF(itemIds: string[]) {
  const fns = getFunctions(undefined, "europe-west1");
  const fn = httpsCallable(fns, "createInvoiceReport");
  const res = await fn({ itemIds });
  const data = res?.data as CreateInvoiceReportResponse;

  if (!data?.ok) {
    throw new Error(data?.message || "Kunde inte skapa fakturarapport.");
  }
  return data;
}
